export const REPORT_TYPES = {
  IRRELEVANT_CONTENT: "IRRELEVANT_CONTENT",
  SPAM: "SPAM",
  OBSCENE_CONTENT: "OBSCENE_CONTENT",
  HATE_SPEECH: "HATE_SPEECH",
};
